
module.exports.temp2rgb = function(T) {
  var RGB, T100;
  T100 = T / 100;
  RGB = [];
  if (T <= 6504) {
    RGB[0] = 255;
    RGB[1] = T100;
    RGB[1] = 99.4708025861 * Math.log(RGB[1]) - 161.1195681661;
    if (RGB[1] < 0) {
      RGB[1] = 0;
    }
    if (RGB[1] > 255) {
      RGB[1] = 255;
    }
  } else {
    RGB[0] = T100 - 60;
    RGB[0] = 329.698727446 * Math.pow(RGB[0], -0.1332047592);
    if (RGB[0] < 0) {
      RGB[0] = 0;
    }
    if (RGB[0] > 255) {
      RGB[0] = 255;
    }
    RGB[1] = T100 - 60;
    RGB[1] = 288.1221695283 * Math.pow(RGB[1], -0.0755148492);
    if (RGB[1] < 0) {
      RGB[1] = 0;
    }
    if (RGB[1] > 255) {
      RGB[1] = 255;
    }
  }
  if (T >= 6504) {
    RGB[2] = 255;
  } else {
    if (T100 <= 19) {
      RGB[2] = 0;
    } else {
      RGB[2] = T100 - 10;
      RGB[2] = 138.5177312231 * Math.log(RGB[2]) - 305.0447927307;
      if (RGB[2] < 0) {
        RGB[2] = 0;
      }
      if (RGB[2] > 255) {
        RGB[2] = 255;
      }
    }
  }
  return RGB;
};